import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import NavDocMain from './NavDocMain';
import NavDocSub from './NavDocSub';
import DocFileTable from './DocFileTable';
import ReviewPlace from './ReviewPlace';
import { loadDocFiles, getDocReviewStatusGroup, 
  getMilestones, getDocReviewStatus } from './thunks';
import { setReviewInfo } from './actions';

import 'bootstrap/dist/css/bootstrap.min.css';
import './AppBaseHome.css';
import './AppReviewHome.css';

const AppHome = ({ 
  files = [], userInfo, reviewInfo,startLoadingDocFiles, startGetDocReviewStatus,
  startSetReviewInfo, startGetDocReviewStatusGroup, startGetMilestones }) => {
  
  // const history = useHistory();
  // const location = useLocation();
  let paramsText = window.location && window.location.search;
  paramsText = paramsText && paramsText.substring(5);
  
  const buf = Buffer.from(paramsText, 'base64');
  const result = buf.toString('ascii');
  const paramItems = result.split(':');
  console.log('>>> result:', result, paramItems);
  const params = {
    program: paramItems[0],
    study: paramItems[1],
    milestone: paramItems[2],
    groupId: paramItems[3],
    user: paramItems[4],
    userId: paramItems[4],
    type: 'doc',
  };
  console.log('AppReviewHome params:', params);
  
  useEffect(() => {
    startLoadingDocFiles(params);
    startSetReviewInfo(params);
    startGetMilestones(params);
    startGetDocReviewStatusGroup(params.groupId);
    startGetDocReviewStatus(params);
  }, 
  // eslint-disable-next-line
  []);
  
  const content = (
    <div className="AppHome">
      <NavDocMain mode={"review"} />
      <NavDocSub mode={"review"} />
      <Container fluid>
        <Row>
          <Col md={3} className="SideContent">
            <DocFileTable allowEdit={true} />
          </Col>
          <Col md={9} className="MainContent">
            <ReviewPlace allowEdit={true} />
          </Col>
        </Row>
      </Container>
    </div>
  );
  
  return content;
};

const mapState = state => ({
  files: state.files,
  userInfo: state.userInfo,
  reviewInfo: state.reviewInfo,
})

const mapDispatch = dispatch => ({
  startLoadingDocFiles: (data) => dispatch(loadDocFiles(data)),
  startGetMilestones: (data) => dispatch(getMilestones(data)),
  startSetReviewInfo: (data) => dispatch(setReviewInfo(data)),
  startGetDocReviewStatusGroup: (data) => dispatch(getDocReviewStatusGroup(data)),
  startGetDocReviewStatus: (data) => dispatch(getDocReviewStatus(data)),
})

export default connect(mapState, mapDispatch)(AppHome);
